export default "__VITE_ASSET__DIhAal4t__"